var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.appointment
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          attrs: { id: "mobile_event_popover" },
        },
        [
          _vm.appointment.type !== "BLOCK_TIME"
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "event-popover-details" },
                      [
                        _c("span", { staticClass: "event-time" }, [
                          _vm._v(
                            _vm._s(
                              _vm.appointment.from + " - " + _vm.appointment.to
                            )
                          ),
                        ]),
                        _vm.currentUser.isInLawIndustry
                          ? [
                              _c("span", { staticClass: "event-client" }, [
                                _vm._v(
                                  _vm._s(_vm.appointment.subject.subjectNumber)
                                ),
                              ]),
                              _c("br"),
                              _c("span", { staticClass: "event-service" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.appointment.subject.courtName) +
                                    " - " +
                                    _vm._s(
                                      _vm.appointment.subject.courtNumber
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("br"),
                            ]
                          : _vm._e(),
                        _c("span", { staticClass: "event-client" }, [
                          _vm._v(_vm._s(_vm.appointmentTitle)),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "event-service",
                            class: {
                              "event-service-deleted":
                                _vm.appointment.service.deleted,
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.appointment.service.name) + " "
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "event-client" }, [
                          _vm._v(
                            _vm._s(_vm.$t("calendar.appointment.employee"))
                          ),
                        ]),
                        _c("span", { staticClass: "event-service" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.appointment.employee.first_name) +
                              " " +
                              _vm._s(_vm.appointment.employee.last_name) +
                              " "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]
                ),
                _vm.canManageAppointment()
                  ? _c("div", { staticClass: "event-notes" }, [
                      _c("span", { staticClass: "event-notes-label" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("calendar.appointment.notesLabel")) +
                            ": "
                        ),
                      ]),
                      _c("span", { staticClass: "event-notes-text" }, [
                        _vm._v(_vm._s(_vm.appointmentNotes)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.canManageAppointment()
                  ? _c("div", { staticClass: "event-action-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "event-cancel-btn",
                          on: { click: _vm.cancelAppointment },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("calendar.appointment.cancelAppointment")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "event-edit-btn",
                          on: { click: _vm.editAppointment },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("calendar.appointment.editAppointment")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.canApproveAppointment(_vm.appointment)
                        ? _c(
                            "button",
                            {
                              staticClass: "event-approve-btn",
                              on: { click: _vm.approveAppointment },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "calendar.appointment.approveAppointment"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("div", { staticClass: "event-popover-details" }, [
                      _c("span", { staticClass: "event-time" }, [
                        _vm._v(
                          _vm._s(
                            _vm.appointment.from + " - " + _vm.appointment.to
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "event-client" }, [
                        _vm._v(_vm._s(_vm.appointment.notes)),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "event-action-buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "event-cancel-btn",
                      on: { click: _vm.removeBlockTime },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("calendar.blockTime.removeBlockTime")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "event-edit-btn",
                      on: { click: _vm.editBlockTime },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("calendar.blockTime.editBlockTime")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }